import { GetServerSidePropsContext, GetServerSidePropsResult } from "next";
import { getSession } from "next-auth/react";
import isLoggedIn from "src/utils/isLoggedIn";
import { getAuthRedirect } from "src/modules/page/utils";
import { LoginOrRegisterView } from "src/organisms/LoginOrRegister";
import getConfig from "next/config";
import { Locale } from "src/lib/Intl";
import LoginPages from "src/Layouts/LoginPages";
import { buildServerSideProps } from "src/utils/static-props/app-page-props";

type LoginPageProps = {
  type: string;
  locale: Locale;
};

function LoginPage({
  pageProps: { type, locale },
}: {
  pageProps: LoginPageProps;
}): JSX.Element {
  return <LoginOrRegisterView locale={locale} type={type} />;
}

const { serverRuntimeConfig } = getConfig();

export async function getServerSideProps({
  req,
  res,
  query,
}: GetServerSidePropsContext): Promise<
  GetServerSidePropsResult<LoginPageProps>
> {
  const session = await getSession({ req });
  if (session && isLoggedIn(session)) {
    return getAuthRedirect({ req, res, query, session });
  }

  return buildServerSideProps({
    type: query.type as string,
    locale: serverRuntimeConfig.LOCALE as Locale,
  });
}

LoginPage.Layout = LoginPages;

export default LoginPage;
